
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './bootstrap';
import './assets/css/app.css';
import axios from 'axios';

// Vuetify
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

axios.defaults.withCredentials = true;

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#07d2f2',
          secondary: '#00C2A8',
          background: '#efefef',
          backgroundnegative: '#1E1E1E',
          surface: '#F5F5F5',
          text: '#000000',
        }
      },
      dark: {
        colors: {
          primary: '#07d2f1',
          secondary: '#00C2A8',
          background: '#121212',
          backgroundnegative: '#efefef',
          surface: '#1E1E1E',
          text: '#FFFFFF',
        }
      }
    }
  }
});

const app = createApp(App);
app.use(router);
app.use(vuetify);
app.mount('#app');


import { watchEffect } from 'vue'

// Accés al gestor de temes
const themeManager = vuetify.theme

function applyTheme(themeObjOrName) {
  const allThemes = themeManager.themes.value

  // Si ens han passat objecte → busquem quin tema és
  let themeName = themeObjOrName
  let themeData = null

  if (typeof themeObjOrName === 'string') {
    // Cas A: és un nom directe "light" o "dark"
    themeName = themeObjOrName
    themeData = allThemes[themeName]
  } else if (typeof themeObjOrName === 'object') {
    // Cas B: és un objecte de tema → l’hem de trobar
    themeData = Object.values(allThemes).find(
      t => t.colors.primary === themeObjOrName.colors.primary
    )
  }

  if (!themeData) {
    console.warn("No s’ha pogut identificar el tema:", themeObjOrName)
    return
  }

  // Aplicar colors com a variables CSS
  const root = document.documentElement

  Object.entries(themeData.colors).forEach(([key, value]) => {
    root.style.setProperty(`--color-${key}`, value)
  })
}

// Aplicar tema inicial
applyTheme(themeManager.global.current.value)

// Tornar a aplicar quan canvies de tema
watchEffect(() => {
  applyTheme(themeManager.global.current.value)
})